import { render, staticRenderFns } from "./ShopPasswordForm.vue?vue&type=template&id=2fc914ef&scoped=true&"
import script from "./ShopPasswordForm.vue?vue&type=script&lang=js&"
export * from "./ShopPasswordForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc914ef",
  null
  
)

export default component.exports